// extracted by mini-css-extract-plugin
module.exports = {"devButton":"hitos_devButton__3Q2Po"};